import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Jollof Fit Kingdom";
const DEFAULT_DESC =
  "Jollof Fit Kingdom is a premium fitness platform designed to help people build healthier lifestyles through personalized coaching, wellness insights, workout tracking, nutrition, recovery, and connected health technology.";

export default function Seo({ title, description, path = "/", image, noindex = false }) {
  const fullTitle = title ? `${title} — ${SITE}` : `${SITE} | Build Today. Rule Tomorrow.`;
  const desc = description || DEFAULT_DESC;
  const url = `https://jolloffitkingdom.com${path}`;
  const ogImage = image || "https://jolloffitkingdom.com/jollof-og-eagle.jpg";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Jollof Fit Kingdom — cinematic eagle emblem in black and gold" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content="Jollof Fit Kingdom — cinematic eagle emblem in black and gold" />
    </Helmet>
  );
}
